import React, { useState } from "react";
import Button from "../base/buttons/Button";
import Dropbutton from "../base/buttons/DropButton";
import {
  CiAlarmOff,
  CiFries,
  CiLocationArrow1,
  CiSearch,
  CiViewList,
} from "react-icons/ci";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { BsTelephone, BsGear, BsPeople } from "react-icons/bs";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { FiBell } from "react-icons/fi";
import { CiHome } from "react-icons/ci";
const data = [
  { name: "Home", icon: <CiHome /> },
  { name: "Search", icon: <CiSearch /> },
  { name: "Engage", icon: <CiLocationArrow1 /> },
  { name: "Plays", icon: <CiFries /> },
  { name: "Enrich", icon: <CiAlarmOff /> },
];

const Header = () => {
  const [onClick, setOnClick] = useState(false);
  const handleClick = () => {
    setOnClick(!onClick);
  };
  return (
    <header className="">
      <div className="flex flex-row h-12 items-center justify-between w-auto">
        <div className="flex-auto items-center hidden lg:flex space-x-4">
          {data.map((item, index) => {
            return (
              <div key={index} className="flex items-center px-2 hover:text-blue-800 font-semibold">
                <div className="hover:text-blue-400 text-lg">{item.icon}</div>
                <Button key={index} children={item.name} />
              </div>
            );
          })}
        </div>
        <div className="flex items-center">
          <Dropbutton text="Apollo Guide" />
          <Button
            children="Upgrade"
            primary
            className="h-8 rounded-sm text-sm"
          />
          <div className="flex items-center border h-8 m-1">
            <form className="px-4">
              <div className="flex items-center">
                <CiSearch />
                <input
                  type="text"
                  placeholder="Search..."
                  className="px-2 focus:outline-none"
                />
              </div>
            </form>
          </div>
          <div className="flex items-center">
            <div className="mx-2 hover:text-blue-600">
              <BsTelephone />
            </div>
            <div className="mx-2 hover:text-blue-600">
              <AiOutlineInfoCircle />
            </div>
            <div className="mx-2 hover:text-blue-600 items-center">
              <FiBell />
            </div>
            <div className="mx-2 hover:text-blue-600">
              <BsGear />
            </div>
            <div className="flex justify-center items-center rounded-full  text-xs mr-2 text-center h-8 w-8 bg-gray-300">
              <p>SK</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-row w-auto h-12">
        <div className="flex w-1/4">
          <button
            onClick={handleClick}
            className="flex items-center mx-3 w-1/3 border-b hover:border-blue-600 hover:text-blue-600"
          >
            <BsPeople className="mr-2" />
            People
          </button>
          <button
            onClick={handleClick}
            className="flex items-center mx-3 w-1/3 border-b hover:border-blue-600 hover:text-blue-600"
          >
            <HiOutlineBuildingOffice2 className="mr-2" /> Companies
          </button>
          <button
            onClick={handleClick}
            className="flex items-center mx-3 w-1/3 border-b hover:border-blue-600 hover:text-blue-600"
          >
            <CiViewList className="mr-2" />
            Lists
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
